import { type User } from '@common/clients/api';
import { UserService } from '@common/clients/api/sdk.gen';
import { ApiService } from '@common/clients/request/ApiService';
import { type ContextData } from '@common/defaults/ContextData';
import { type UserContext } from '@common/defaults/UserContext';

export const fetchCurrentUserProfile = async (
    contextData: ContextData,
    userContext: UserContext | undefined,
    isClientSide: boolean = false,
    editionID?: number,
): Promise<User | undefined> => {
    const { data } = await ApiService({
        contextData,
        userContext,
        isClientSide,
        service: UserService,
    }).getProfileByIdUser({
        query: {
            editionID,
        },
    });

    return data;
};
